import SubmissionError from '../../../error/SubmissionError';
import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  FILETYPE_CREATE_ERROR,
  FILETYPE_CREATE_LOADING,
  FILETYPE_CREATE_SUCCESS,
  FILETYPE_CREATE_VIOLATIONS,
  FILETYPE_CREATE_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {}
};

function error(error) {
  return {type: FILETYPE_CREATE_ERROR, error};
}

function loading(loading) {
  return {type: FILETYPE_CREATE_LOADING, loading};
}

function success(created) {
  return {type: FILETYPE_CREATE_SUCCESS, created};
}

function violations(violations) {
  return {type: FILETYPE_CREATE_VIOLATIONS, violations};
}

function reset() {
  return {type: FILETYPE_CREATE_RESET};
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
};

const actions = {
  create({ commit }, values) {
    commit(loading(true));
    commit(violations({}));
    commit(error(null));
    return http.fetch('/file_types', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false));

        return response.json();
      })
      .then(data => {
        commit(success(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors));
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [FILETYPE_CREATE_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [FILETYPE_CREATE_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [FILETYPE_CREATE_SUCCESS] (state, payload) {
      state.created = payload.created;
    },
    [FILETYPE_CREATE_VIOLATIONS] (state, payload) {
      state.violations = payload.violations;
    },
    [FILETYPE_CREATE_RESET] (state) {
      state.loading = false;
      state.error = '';
      state.created = null;
      state.violations = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/filetype/create.js